import EnhancedPostCard from '../post/EnhancedPostCard';

export const ProfilePosts = ({ posts, onLike, onSave, currentUserId, onPostDelete, onPostUpdate }) => {
  if (!posts || posts.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-xl">
        <div className="text-4xl mb-3">📝</div>
        <p className="text-gray-600">No posts yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {posts.map(post => (
        <EnhancedPostCard 
          key={post.id} 
          post={post} 
          currentUserId={currentUserId}
          onPostDelete={onPostDelete}
          onPostUpdate={onPostUpdate}
        />
      ))}
    </div>
  );
};

export default ProfilePosts;
